import React from 'react';
import { PageContent, Query, PenlySeo } from 'components';

import PRIVACY_POLICY_PAGE_QUERY from 'queries/pages/privacyPolicy';

export default function Privatlivspolitik() {
    return (
        <>
            <PenlySeo noindex={ true } />
            <Query query={ PRIVACY_POLICY_PAGE_QUERY }>
                { ({ data: { privacyPolicyPage } }) => <PageContent { ...privacyPolicyPage.content } /> }
            </Query>
        </>
    );
}
